// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectedWorksSection_base__4_EUF","projectGrid":"SelectedWorksSection_projectGrid__c4oHN"};